// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#teacherTests .ant-tabs-tabpane{
    width:98%;
}

.editable-cell {
    display: flex;
    align-items: center;
}

.editable-cell-value-wrap {
    padding: 5px 11px;
    cursor: pointer;
}

.editable-cell-value-wrap:hover {
    padding: 4px 10px;
    border: 1px solid var(--primary-colour);
    border-radius: 2px;
    min-height: 31px;
}

#teacherTestGroups .ant-table-row-level-0 {
    background: #f7fbfb;
}


.ant-table-row-expand-icon-cell {

    position: relative;

}

.ant-table-row-collapsed:after {
    content : "\\E61D";
    font-family: "anticon" !important;
    font-style: normal;
    vertical-align: baseline;
    text-align: center;
    text-transform: none;
    text-rendering: auto;

    right: 16px;
    top: 0;
    display: inline-block;
    transform: scale(0.66666667) rotate(0deg);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    zoom: 1;
}

.ant-table-row-expanded:after {
    content : "\\E61D";
    font-family: "anticon" !important;
    font-style: normal;
    vertical-align: baseline;
    text-align: center;
    text-transform: none;
    text-rendering: auto;

    right: 16px;
    top: 0;
    display: inline-block;
    transform: rotate(180deg) scale(0.75);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    zoom: 1;
}

#testExamReports{
    margin-top:10px;
}

.ant-select-dropdown, .ant-picker-dropdown{
    z-index: 9999;
}

.testFamilyForm{
    display:flex;
    gap:12px;
    flex-direction: column;
}

.testFamilyForm .ant-row{
    gap: 18px;
}

.tabText{
    vertical-align: top;
}

.ant-tabs-tabpane.ant-tabs-tabpane-hidden{
    display:none;
}

#testGroupTopActionBar{
    display: flex;
    justify-content: space-between;
    padding: 10px 4px;
}

#testGroupTopActionBar > div {
    display: flex;
    gap: 12px;
    align-items: center;
}

#testGroupTopActionBar button{
    height: 32px;
}

#testGroupTopActionBar #searchTestGroupInput{
    min-width:250px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

#testGroupTopActionBar .searchButtonWrapper button{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    min-width:unset;
    width:40px;
}

#teacherTestGroups #filterForm{
    position: absolute;
    background: white;
    top: 0;
    left: 40px;
    z-index: 999;
    padding: 10px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .24);
    width: 295px;
}

#teacherTestGroups #filterForm .ant-form-item-label{
    padding-bottom:0;
    border-bottom:1px solid lightgrey;
    height:30px;
}

#teacherTestGroups #filterForm .ant-form-item-control-input{
    padding:4px;
}

#testFamilyTable tr[data-row-key="SHARED"] > td {
    border-top: 2px solid lightgrey;
}

#testAssignmentSearchBox{
    align-items: center;
}

#toggleFilterButton.ch-activated{
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

#filterForm .ant-radio-group-solid{
    width: 100%;
    text-align: center;
}

#testAssignmentSearchBox .ant-card-body{
    flex-direction: column;
}

#testAssignmentsFollowUp .ant-list-items{
    gap: 8px;
    flex-direction: column;
    display: flex;
}

#skill-select-view .ag-header-cell-text{
    text-wrap: initial;
    text-overflow: ellipsis;
}

/*.ch-general-table-ag-grid table > thead > tr:first-child th:last-child{*/
/*    border-top-right-radius: 5px;*/
/*}*/

/*.ch-general-table-ag-grid table > thead > tr:first-child th:first-child{*/
/*    border-top-left-radius: 5px;*/
/*}*/

#classAssignForm .ant-form-item-label, #classSearchForm .ant-form-item-label, #studentResultsFilterForm .ant-form-item-label{
    width:100%;
}

#classAssignForm .ant-radio-group, #studentResultsFilterForm .ant-radio-group{
    margin-top:12px;
}

.ch-list-item:first-child > .assign-follow-up-work-card {margin-top: var(--medium-spacing-unit)}

.assign-follow-up-work-card .assign-test-pie-chart-wrapper:first-child {
    width: 48px;
    height: 48px;
}

.test-inprogress {
    color: var(--secondary-colour);
}

.editAssignTestForm .ant-radio-group {
    width: 100%;
}

.edit-assign-dialog.select-checkbox-wrapper {
    padding: 4px 8px
}

.dialog-form-tooltip-wrapper {
    position: relative;
    width: 0;
    height: 0;
}

.tooltip-wrapper {
    font-size: 14px;
}

.dialog-form-tooltip-wrapper span {
    position: absolute;
}

#skill-select-view .ag-header-group-cell {
    overflow: hidden;
}

.wrap-table-header {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.wrap-table-header .label {
    overflow-y: auto;
    white-space: break-spaces;
    max-height: 62px;
    min-width: 110px;
}

.ag-pinned-left-cols-container .no-hover {
    color: var(--focus-on-primary);
}

.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell {
    padding: 0 4px;
}
@media screen and (max-width: 420px) {
    #testRecipientHelpBlk{
        flex-wrap: wrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/main/ui/tests/teacher/teacherTests.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;;IAEI,kBAAkB;;AAEtB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;;IAEpB,WAAW;IACX,MAAM;IACN,qBAAqB;IACrB,yCAAyC;IACzC,+DAA+D;IAC/D,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;;IAEpB,WAAW;IACX,MAAM;IACN,qBAAqB;IACrB,qCAAqC;IACrC,+DAA+D;IAC/D,OAAO;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,MAAM;IACN,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;IACR,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,0EAA0E;AAC1E,oCAAoC;AACpC,IAAI;;AAEJ,2EAA2E;AAC3E,mCAAmC;AACnC,IAAI;;AAEJ;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA,yDAAyD,sCAAsC;;AAE/F;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;AACA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":["#teacherTests .ant-tabs-tabpane{\n    width:98%;\n}\n\n.editable-cell {\n    display: flex;\n    align-items: center;\n}\n\n.editable-cell-value-wrap {\n    padding: 5px 11px;\n    cursor: pointer;\n}\n\n.editable-cell-value-wrap:hover {\n    padding: 4px 10px;\n    border: 1px solid var(--primary-colour);\n    border-radius: 2px;\n    min-height: 31px;\n}\n\n#teacherTestGroups .ant-table-row-level-0 {\n    background: #f7fbfb;\n}\n\n\n.ant-table-row-expand-icon-cell {\n\n    position: relative;\n\n}\n\n.ant-table-row-collapsed:after {\n    content : \"\\E61D\";\n    font-family: \"anticon\" !important;\n    font-style: normal;\n    vertical-align: baseline;\n    text-align: center;\n    text-transform: none;\n    text-rendering: auto;\n\n    right: 16px;\n    top: 0;\n    display: inline-block;\n    transform: scale(0.66666667) rotate(0deg);\n    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    zoom: 1;\n}\n\n.ant-table-row-expanded:after {\n    content : \"\\E61D\";\n    font-family: \"anticon\" !important;\n    font-style: normal;\n    vertical-align: baseline;\n    text-align: center;\n    text-transform: none;\n    text-rendering: auto;\n\n    right: 16px;\n    top: 0;\n    display: inline-block;\n    transform: rotate(180deg) scale(0.75);\n    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    zoom: 1;\n}\n\n#testExamReports{\n    margin-top:10px;\n}\n\n.ant-select-dropdown, .ant-picker-dropdown{\n    z-index: 9999;\n}\n\n.testFamilyForm{\n    display:flex;\n    gap:12px;\n    flex-direction: column;\n}\n\n.testFamilyForm .ant-row{\n    gap: 18px;\n}\n\n.tabText{\n    vertical-align: top;\n}\n\n.ant-tabs-tabpane.ant-tabs-tabpane-hidden{\n    display:none;\n}\n\n#testGroupTopActionBar{\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 4px;\n}\n\n#testGroupTopActionBar > div {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n#testGroupTopActionBar button{\n    height: 32px;\n}\n\n#testGroupTopActionBar #searchTestGroupInput{\n    min-width:250px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n#testGroupTopActionBar .searchButtonWrapper button{\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    min-width:unset;\n    width:40px;\n}\n\n#teacherTestGroups #filterForm{\n    position: absolute;\n    background: white;\n    top: 0;\n    left: 40px;\n    z-index: 999;\n    padding: 10px;\n    border-top-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .24);\n    width: 295px;\n}\n\n#teacherTestGroups #filterForm .ant-form-item-label{\n    padding-bottom:0;\n    border-bottom:1px solid lightgrey;\n    height:30px;\n}\n\n#teacherTestGroups #filterForm .ant-form-item-control-input{\n    padding:4px;\n}\n\n#testFamilyTable tr[data-row-key=\"SHARED\"] > td {\n    border-top: 2px solid lightgrey;\n}\n\n#testAssignmentSearchBox{\n    align-items: center;\n}\n\n#toggleFilterButton.ch-activated{\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n}\n\n#filterForm .ant-radio-group-solid{\n    width: 100%;\n    text-align: center;\n}\n\n#testAssignmentSearchBox .ant-card-body{\n    flex-direction: column;\n}\n\n#testAssignmentsFollowUp .ant-list-items{\n    gap: 8px;\n    flex-direction: column;\n    display: flex;\n}\n\n#skill-select-view .ag-header-cell-text{\n    text-wrap: initial;\n    text-overflow: ellipsis;\n}\n\n/*.ch-general-table-ag-grid table > thead > tr:first-child th:last-child{*/\n/*    border-top-right-radius: 5px;*/\n/*}*/\n\n/*.ch-general-table-ag-grid table > thead > tr:first-child th:first-child{*/\n/*    border-top-left-radius: 5px;*/\n/*}*/\n\n#classAssignForm .ant-form-item-label, #classSearchForm .ant-form-item-label, #studentResultsFilterForm .ant-form-item-label{\n    width:100%;\n}\n\n#classAssignForm .ant-radio-group, #studentResultsFilterForm .ant-radio-group{\n    margin-top:12px;\n}\n\n.ch-list-item:first-child > .assign-follow-up-work-card {margin-top: var(--medium-spacing-unit)}\n\n.assign-follow-up-work-card .assign-test-pie-chart-wrapper:first-child {\n    width: 48px;\n    height: 48px;\n}\n\n.test-inprogress {\n    color: var(--secondary-colour);\n}\n\n.editAssignTestForm .ant-radio-group {\n    width: 100%;\n}\n\n.edit-assign-dialog.select-checkbox-wrapper {\n    padding: 4px 8px\n}\n\n.dialog-form-tooltip-wrapper {\n    position: relative;\n    width: 0;\n    height: 0;\n}\n\n.tooltip-wrapper {\n    font-size: 14px;\n}\n\n.dialog-form-tooltip-wrapper span {\n    position: absolute;\n}\n\n#skill-select-view .ag-header-group-cell {\n    overflow: hidden;\n}\n\n.wrap-table-header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.wrap-table-header .label {\n    overflow-y: auto;\n    white-space: break-spaces;\n    max-height: 62px;\n    min-width: 110px;\n}\n\n.ag-pinned-left-cols-container .no-hover {\n    color: var(--focus-on-primary);\n}\n\n.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell {\n    padding: 0 4px;\n}\n@media screen and (max-width: 420px) {\n    #testRecipientHelpBlk{\n        flex-wrap: wrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
